import { Routes } from "@angular/router";
import { ROUTE_SEGMENTS } from "@shared/constants/app-routes.constants";
import { authGuard } from "./core";
import { MenuMeta } from "./core/models/menu-meta";

export const routes: Routes = [
  {
    path: "",
    loadComponent: () => import("./pages/main/main").then((m) => m.Main),
    canActivate: [authGuard],
  },
  {
    path: ROUTE_SEGMENTS.MANAGEMENT,
    loadChildren: () =>
      import("./pages/management/management.routes").then(
        (m) => m.managementRoutes,
      ),
    canActivate: [authGuard],
    data: {
      menu: {
        label: "Management",
        icon: "account_tree",
        group: true,
      } satisfies MenuMeta,
    },
  },
  {
    path: ROUTE_SEGMENTS.WORKFLOW,
    loadChildren: () =>
      import("./pages/workflow/workflow.routes").then((m) => m.workflowRoutes),
    canActivate: [authGuard],
    data: {
      menu: {
        label: "Workflow",
        icon: "fact_check",
        group: true,
      } satisfies MenuMeta,
    },
  },
  {
    path: ROUTE_SEGMENTS.STORAGE_ACCOUNT,
    loadChildren: () =>
      import("./pages/storage-account/storage-account.routes").then(
        (m) => m.storageAccountRoutes,
      ),
    canActivate: [authGuard],
    data: {
      menu: {
        label: "Storage Account",
        icon: "cloud",
        group: true,
      } satisfies MenuMeta,
    },
  },
  {
    path: ROUTE_SEGMENTS.SETTINGS,
    loadChildren: () =>
      import("./pages/settings/setting.routes").then((m) => m.settingRoutes),
    canActivate: [authGuard],
    data: {
      menu: {
        label: "Settings",
        icon: "settings",
        group: true,
      } satisfies MenuMeta,
    },
  },
];
